// src/utils/clientErrorReporter.js
import cloudFunctionsEndpoint from "../config/cloudFunctionsEndpoint"

export const reportClientError = async (payload) => {
  const endpoint = `${cloudFunctionsEndpoint()}/reportClientError`

  try {
    await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
  } catch (err) {
    console.warn("Failed to send error report:", err)
  }
}
